/**
 * @ngdoc directive
 * @name diaporama
 *
 * @description
 * Diaporama
 */
module.directive('diaporama', ['$timeout', '$document', '$window', 'lodash', function ($timeout, $document, $window, lodash) {
    'use strict';
    return {
        restrict: 'E',
        scope: {
            diapos: '=',
            overlay: '@?',
            current: '=?',
            downloadable: '@?',
            delay: '@?',
            type: '@?',
            nid: '@?',
            theme: '=?'
        },
        link: function ($scope, element) {
            var getSliderWidth = function () {
                var position = element[0].getBoundingClientRect();
                return position.width;
            };
            var keymap = {
                left: 37,
                right: 39
            };
            var timer;
            var delay = ($scope.delay || 0) * 1000;

            $scope.type = $scope.type || 'normal';
            $scope.current = $scope.current || 0;
            $scope.count = $scope.diapos.length;
            $scope.slides = [];
            $scope.slides.length = parseInt($scope.count || 0);
            $scope.pause = false;

            $scope.containerwidth = '0';
            $scope.safedisplay = false;

            $scope.autoplay = function () {
                if (delay === 0 && $scope.count > 0) {
                    return;
                }
                $timeout.cancel(timer);
                timer = $timeout(function () {
                    if ($scope.current < $scope.count - 1) {
                        $scope.next();
                    } else {
                        $scope.setSlide(0);
                    }
                }, delay);
            };

            $scope.setSlide = function (idx) {
                $scope.current = idx;
                if (!$scope.pause) {
                    $scope.autoplay();
                }
            };
            $scope.prev = function () {
                $scope.current = Math.max(0, $scope.current - 1);
                if (!$scope.pause) {
                    $scope.autoplay();
                }
            };
            $scope.next = function () {
                $scope.current = Math.min($scope.count - 1, $scope.current + 1);
                if (!$scope.pause) {
                    $scope.autoplay();
                }
            };

            // stop autoplay if cursor is hover
            $scope.onEnter = function () {
                $timeout.cancel(timer);
                $scope.pause = true;
            };
            // restart autoplay
            $scope.onLeave = function () {
                $scope.pause = false;
                $scope.autoplay();
            };

            // test whenever diaporama is visible (to prevent transformation while not visible)
            $scope.isVisible = function () {
                var tester = element[0].getBoundingClientRect();
                return (
                    (tester.top >= 0 && tester.top <= ($window.innerHeight || $document[0].documentElement.clientHeight)) ||
                    (tester.bottom >= 0 && tester.bottom <= ($window.innerHeight || $document[0].documentElement.clientHeight))
                );
            };

            // keyboard navigation
            $scope.onKeyDown = function (event) {
                if ($scope.count < 1 || (event.which !== keymap.left && event.which !== keymap.right) || !$scope.isVisible()) {
                    return;
                }

                if (event.which === keymap.left) {
                    // left
                    $scope.prev();
                } else if (event.which === keymap.right) {
                    // right
                    $scope.next();
                }
            };

            // attach event handler
            angular.element($document[0]).on('keydown', $scope.onKeyDown);
            var clearSliderWidth = function () {
                $scope.containerwidth = getSliderWidth();
            };
            var initSliderWidth = function () {
                $scope.containerwidth = getSliderWidth();
                $scope.safedisplay = true;

                // reestimate when resized
                $window.onresize = lodash.throttle(clearSliderWidth, 1000);
            };
            var timerlaunch = $timeout(function () {
                // let browser rendering time
                initSliderWidth();
                // start autoplay
                $scope.autoplay();
            }, 500);


            // remove event handler & timer
            $scope.$on('$destroy', function () {
                angular.element($document[0]).off('keydown', $scope.onKeyDown);
                $window.onresize = null;
                $timeout.cancel(timerlaunch);
            });


        },
        template:
                '<div class="aqua-diaporama" ng-swipe-left="next()" ng-swipe-right="prev()" ng-mouseenter="onEnter()" ng-mouseleave="onLeave()">' +
                '  <a ng-attr-name="{{nid}}"></a>' +
                /* diaporama slide */
                '  <div ng-if="safedisplay" class="aqua-diaporama--items grid" ng-style="{transform:\'translateX(\' + (-current * containerwidth) + \'px)\', \'width\': (containerwidth * count) + \'px\'}">' +
                '    <div class="aqua-diaporama--item grid grid-v grid-auto" ng-repeat="diapo in diapos" ng-style="{\'width\': containerwidth + \'px\'}">' +
                /* diaporama picture (background) */
                '      <div class="aqua-diaporama--picture aqua-diaporama--picture-background" ng-if="type !== \'viewer\'" aqua-background-img="{{diapo.src}}">' +
                /* overlay for picture darkness */
                '        <div class="aqua-diaporama--overlay" ng-if="!!overlay"></div>' +
                '      </div>' +
                /* diaporama picture (img) */
                '      <div class="aqua-diaporama--picture aqua-diaporama--picture-background-contain" ng-if="type === \'viewer\'" aqua-background-img="{{diapo.src}}">' +
                // '      <div class="aqua-diaporama--picture aqua-diaporama--picture-embedded grid grid-v grid-center" ng-if="type === \'viewer\'">' +
                // '        <img class="aqua-diaporama--picture-img" aqua-src="{{diapo.url}}" ng-attr-alt="{{diapo.alt}}">' +
                '        <a ng-if="downloadable === \'1\'" href="{{diapo.src}}" class="aqua-diaporama--download" target="_blank" download>Télécharger l\'image</a>' +
                '      </div>' +
                /* diaporama video */
                '      <div class="aqua-diaporama--video" ng-if="diapo.type === \'video\'">' +
                '        <iframe width="983" height="553" aqua-src="{{diapo.src | trustAsResourceUrl}}" frameborder="0" allowfullscreen></iframe>' +
                '      </div>' +
                /* content */
                '      <div class="aqua-diaporama--content grid grid-v grid-right" ng-if="diapo.title">' +
                '        <h1 class="aqua-diaporama--title" ng-style="{\'color\': theme.color_title}">{{diapo.title}}</h1>' +
                '        <p class="aqua-diaporama--text" ng-style="{\'color\': theme.color_text}">{{diapo.alt}}</p>' +
                '      </div>' +
                /* link */
                '      <a class="aqua-diaporama--link" ng-if="diapo.url" ng-href="{{diapo.url}}"><span class="is-sr-only">En savoir plus{{ \' : \' + diapo.title }}</span></a>' +
                '    </div>' +
                '  </div>' +
                /* diaporama navigation */
                '  <ol class="aqua-diaporama--dots grid grid-center grid-middle grid-nw" ng-show="slides.length > 1">' +
                '    <li ng-click="setSlide($index)" class="aqua-diaporama--dot" ng-repeat="slide in slides track by $index" ng-class="{\'is-current\': current === $index}"></li>' +
                '  </ol> ' +
                '</div>'
    };
}])
    .filter('trustAsResourceUrl', ['$sce', function ($sce) {
        'use strict';
        return function (src) {
            return $sce.trustAsResourceUrl(src);
        };
    }]);
